module.exports = __webpack_public_path__ + "static/flags/MV-6b04b34fe8c5b1c9a1e8875bc04584ba.gif";